import {get} from "../helper";
import {GET_HOME_DATA_API} from "../constants/Home";

export const getHomeData = () => (dispatch) => {
    dispatch({type: GET_HOME_DATA_API, loading: true, payload: {}});
    get('mobilehome')
        .then(({data}) => {
            let payload = {
                homeBanners: (data && data.blockone) ? data.blockone: [],
                ordering: (data && data.blocktwo) ? data.blocktwo: [],
                deals: (data && data.blockthree) ? data.blockthree: []
            };
            dispatch({type: GET_HOME_DATA_API, loading: false, payload });
        })
        .catch((error) => {
            dispatch({type: GET_HOME_DATA_API, loading: false, payload: {}});
            console.log('error', error)
        });
};
